module.exports = __webpack_public_path__ + "static/sm_img02@2x-37dd7b26f21dcaf839567641c34111f7.jpg";